import React from "react";

const skillCategories = [
  {
    name: "Frontend",
    skills: ["React", "React Native", "TypeScript", "Redux", "Tailwind CSS", "Material UI", "HTML/CSS"],
  },
  {
    name: "Backend",
    skills: ["Node.js", "Python/FastAPI", "Go", "PHP/Laravel", "MySQL", "MongoDB", "PostgreSQL"],
  },
  {
    name: "Cloud & DevOps",
    skills: ["AWS Lambda", "GCP", "IBM Cloud", "Docker", "Datadog", "Caddy", "Linux", "CI/CD"],
  },
  {
    name: "Tools & Practices",
    skills: ["Git", "Agile", "OAuth2/OIDC", "Jest/RTL", "N8n", "Jira"],
  },
];

const About = () => {
  return (
    <div className="mt-8">
      <h3 className="text-h3 m-0 mb-6 text-primary-dark">Technical Skills</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {skillCategories.map((category) => (
          <div
            key={category.name}
            className="rounded-lg border border-border bg-bg-body2 p-5"
          >
            <h4 className="text-h4 m-0 mb-3 text-primary-main">{category.name}</h4>
            <div className="flex flex-wrap gap-2">
              {category.skills.map((skill) => (
                <span
                  key={skill}
                  className="px-3 py-1 rounded-full text-sm bg-bg-body3 text-txt-contrast border border-border hover:border-primary-main transition-colors duration-200"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
